import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// FP-LEARNER-STORE-RETIREMENT-01: Zustand holds only UI-selection state.
// Server-authoritative learner data (the list, status, placement_band,
// curriculum, settings, etc.) lives in the ['learners'] React Query —
// see hooks/useLearners.js and hooks/useLearner.js.
//
// Persisted fields:
//   activeLearnerId — which learner the parent has selected. Survives
//     reload so the dashboard / reader / practice pages return to the same
//     learner across sessions.
//   userId          — identity stamp. App.jsx initApp clears this store
//     when the persisted userId doesn't match the freshly-fetched user,
//     guarding against a logout-of-A → login-as-B leakage. (The leak shape
//     is narrower now since no learner data is persisted, but the stamp
//     still protects activeLearnerId from carrying across users.)
//
// Key bumped to v2 so existing browsers' linguapals-learner blob (which
// included the full learners[] + activeLearner) is evicted on next load
// rather than carried forward.
export const useLearnerStore = create(
  persist(
    (set) => ({
      activeLearnerId: null,
      userId: null,

      setActiveLearnerId: (id) => set({ activeLearnerId: id }),
      setUserId: (id) => set({ userId: id }),
      clearLearners: () => set({ activeLearnerId: null, userId: null }),
    }),
    {
      name: 'linguapals-learner-v2',
      partialize: (state) => ({
        userId: state.userId,
        activeLearnerId: state.activeLearnerId,
      }),
    }
  )
);
